// import React from "react";
// import { Card, Row, Col, Alert } from "react-bootstrap";
// import Flex from "components/common/Flex";
// import MobileNotification from "./MobileNotification";
// import NotificationSettings from "components/admin/notification-settings";

// const DefaultSettingMain = () => {

import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Card, Tabs, Tab, Container, Row, Col } from "react-bootstrap";
import DefaultSetting from "./DefaultSetting";
import Flex from "components/common/Flex";
import MobileNotification from "./MobileNotification";
import { FacilitySettings, GroupDefaults } from "./InventoryConfig";
import ReportsNotification from "../../medpass/ReportsNotification";
import axios from "helpers/api";
import NotificationSettings from "components/admin/notification-settings";

const DefaultSettingMain = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const requestedTab = searchParams.get("tab") || location.state?.activeTab || "advanced";
  // "inventory" was the old single inventory tab; it now opens Facility Settings.
  const initialTab = requestedTab === "inventory" ? "facility" : requestedTab;

  const [activeTab, setActiveTab] = useState(initialTab);
  const [groupName, setGroupName] = useState("");

  // Facility handed over from the Group Defaults tab via its Configure button.
  const [facilityToConfigure, setFacilityToConfigure] = useState(null);
    const roleId = Number(localStorage.getItem('roleId'));
  // Role 1 (SuperAdmin), Role 2 (PharmAdmin), Role 4 (GroupAdmin) can manage timing
  const canAccessTiming = roleId === 1 || roleId === 2;
  // Role >= 4 can manage recipients per facility
  const canAccessRecipients = roleId >= 4;


  // Group name for the page header.
  useEffect(() => {
    const groupId =
      localStorage.getItem("groupId") || localStorage.getItem("group_id") || "61175";
    if (!groupId) return;

    const tokenStr = localStorage.getItem("accessToken");
    const baseUrl = process.env.REACT_APP_SERVER_URL || "";
    const url = baseUrl
      ? `${baseUrl}/inventory/config/group/${groupId}`
      : `/inventory/config/group/${groupId}`;

    let cancelled = false;

    axios
      .get(url, { headers: tokenStr ? { Authorization: `Bearer ${tokenStr}` } : {} })
      .then((res) => {
        const gData = res.data?.data || res.data?.config || res.data;
        if (!cancelled && gData?.group_name) {
          setGroupName(gData.group_name);
        }
      })
      .catch((err) => {
        console.warn("Group name fetch warning:", err?.message);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const handleConfigureFacility = (facility) => {
    setFacilityToConfigure(facility);
    setActiveTab("facility");
  };

  const handleTabSelect = (key) => {
    // Leaving the facility tab clears the hand-off so it opens on the list next time.
    if (key !== "facility") setFacilityToConfigure(null);
    setActiveTab(key);
  };

  return (
    <>
      <Card className="mb-3">
        <Card.Header className="pb-0 pt-4 mb-2">
          <h4 className="mb-1">
            {groupName || 'Mobile Notification Settings'}
          </h4>
          {/* <h4 className="mb-1">{groupName || "Group Settings"}</h4> */}
        </Card.Header>
        <Card.Body className="py-0 mb-4">
          <Row className="align-items-center">
            {roleId > 3 && groupName && (
              <Col lg={4} className="ps-2 ps-lg-3 me-0 ms-auto">
                <Flex alignItems="center" className="mb-2">
                  <div className="flex-1">
                    <h6 className="mb-0">Group Name: {groupName}</h6>
                  </div>
                </Flex>
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>
      <Card className="p-3">
        <Tabs activeKey={activeTab} onSelect={handleTabSelect}>
          {/* <Tab eventKey="general" title="Group Settings">
            <DefaultSetting />
          </Tab> */}
          <Tab eventKey="advanced" title="Mobile Notifications" unmountOnExit>
            {canAccessTiming || canAccessRecipients ? (
              <div className="p-3">
                {canAccessTiming && <NotificationSettings />}
                {canAccessRecipients && <MobileNotification />}
              </div>
            ) : (
              <Card className="p-3">
                <Alert variant="warning" className="m-3">
                  You do not have permission to view or edit notification settings.
                </Alert>
              </Card>
            )}
          </Tab>
          <Tab eventKey="facility" title="Facility Settings" unmountOnExit>
            <FacilitySettings
              key={facilityToConfigure?.facility_id || "list"}
              initialFacility={facilityToConfigure}
            />
          </Tab>
          <Tab eventKey="group" title="Group Defaults" unmountOnExit>
            <GroupDefaults onConfigureFacility={handleConfigureFacility} />
          </Tab>
          {/* <Tab eventKey="report" title="Report">
              <ReportsNotification />
            </Tab> */}
        </Tabs>
      </Card>
    </>
  );
};

export default DefaultSettingMain;


